import { render } from "./Training.vue?vue&type=template&id=25c177d6&scoped=true"
import script from "./Training.vue?vue&type=script&lang=js"
export * from "./Training.vue?vue&type=script&lang=js"

import "./Training.vue?vue&type=style&index=0&id=25c177d6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-25c177d6"

export default script